import $ from 'jquery'

$('a').on('click', function (e) {
  const url = $(this).attr('href')

  if (url.indexOf('.pdf', url.length - 4) != -1) {
    e.preventDefault()
    window.open(url, '_blank')
  }
})


// WEBPACK FOOTER //
// ./js/classes/pdf-links.js